import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import {
  SpacingVertical,
  SPACING_4,
  SPACING_8,
  TruncateAndTooltip,
  ProgressBarSmall,
  Panel,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  ThumbContainer,
  Thumb,
  FormElement,
  Select,
  Flex,
  FlexItem
} from 'mailup-web-components'
import BoxThumbnail from './BoxThumbnail'
import './AbTestWinnerMessage.scss'

import { abTestState } from '../recoil/state/abTest'

const AbTestWinnerMessage = () => {
  const intl = useIntl()
  const {
    Info,
    Messages,
    testNotStartMode,
    testRunning,
    testEnded,
    testStopped,
    winnerMessageScheduledManualMode,
    sendingWinner,
    testCompleted,
    winnerSendStopped,
    idWinnerMessageManual,
    idWinnerMessageManualIsDirty
  } = useRecoilValue(abTestState)
  const setAbTestState = useSetRecoilState(abTestState)

  const getTitle = () => {
    if (Info.TipoTest === 'A') {
      if (Info.Criterio === 1) {
        return intl.formatMessage({
          id: 'Load.AbTest.SendWinnerMessageAutoBestOpenDescr'
        })
      }
      if (Info.Criterio === 2) {
        return intl.formatMessage({
          id: 'Load.AbTest.SendWinnerMessageAutoBestClickDescr'
        })
      }
    }
    if (Info.TipoTest === 'M') {
      return intl.formatMessage({
        id: 'Load.AbTest.SendWinnerMessageManualDescr'
      })
    }
  }

  const onChangeWinnerMessageManual = value => {
    setAbTestState(prev => ({
      ...prev,
      idWinnerMessageManual: value,
      IsDirty: true,
      idWinnerMessageManualIsDirty: true
    }))
  }

  const getDescMsg = item => {
    let ret =
      intl.formatMessage({ id: 'Load.MailupCommon.Id' }) +
      ' ' +
      item.IdMessaggio
    if (item.Note) {
      ret += ' - ' + item.Note
    }
    return ret
  }
  return (
    <Panel collapsible={false}>
      <Flex>
        <FlexItem width='90px' justifySelf='flex-start'>
          {(testNotStartMode ||
            ((testRunning || testEnded || testStopped) &&
              !winnerMessageScheduledManualMode)) && (
            <ThumbContainer>
              <Thumb>
                <span className='abtest_manage-winner_message_icon' />
              </Thumb>
            </ThumbContainer>
          )}
          {!testNotStartMode &&
            (sendingWinner ||
              testCompleted ||
              winnerSendStopped ||
              winnerMessageScheduledManualMode) && (
              <BoxThumbnail item={Messages.find(m => m.TipoInvio === 2)} />
            )}
        </FlexItem>
        <FlexItem
          margin='0 0 0 24px'
          justifySelf='flex-end'
          width='calc(100% - 125px)'
        >
          <SpacingVertical variant={SPACING_4} />
          {(testNotStartMode ||
            testRunning ||
            testStopped ||
            (testEnded && Info.TipoTest === 'A')) && (
            <>
              <Text variant={TEXT_VARIANT_BOLD}>
                <TruncateAndTooltip text={getTitle()} />
              </Text>
              <SpacingVertical variant={SPACING_8} />
            </>
          )}
          {testEnded &&
            Info.TipoTest === 'M' &&
            !winnerMessageScheduledManualMode && (
              <>
                <FormElement
                  required
                  label={
                    !winnerMessageScheduledManualMode
                      ? intl.formatMessage({ id: 'Load.AbTest.WinnerMessage' })
                      : ''
                  }
                  feedback={
                    !idWinnerMessageManual && idWinnerMessageManualIsDirty
                      ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                      : undefined
                  }
                >
                  <Select
                    placeholder={intl.formatMessage({
                      id: 'Load.AbTest.SelectMessageToSend'
                    })}
                    value={idWinnerMessageManual}
                    options={Messages.filter(f => f.TipoInvio === 1).map(m => ({
                      label: m.IdMessaggio + ' ' + m.Subject,
                      value: m.IdMessaggio
                    }))}
                    error={
                      !idWinnerMessageManual && idWinnerMessageManualIsDirty
                    }
                    searchable={false}
                    onChange={onChangeWinnerMessageManual}
                    data-mu-test='abTestManage-SelectWinnerMessage'
                    className='test-abTestManageSelectWinnerMessage'
                  />
                </FormElement>
                <SpacingVertical variant={SPACING_8} />
              </>
            )}
          {(sendingWinner ||
            testCompleted ||
            winnerMessageScheduledManualMode ||
            winnerSendStopped) && (
            <>
              <Text variant={TEXT_VARIANT_BOLD}>
                <TruncateAndTooltip
                  text={Messages.find(f => f.TipoInvio === 2).Subject}
                />
              </Text>
              <SpacingVertical variant={SPACING_4} />
              <Text variant={TEXT_VARIANT_LIGHT}>
                <TruncateAndTooltip
                  text={getDescMsg(Messages.find(f => f.TipoInvio === 2))}
                />
              </Text>
              <SpacingVertical variant={SPACING_8} />
            </>
          )}
          <Text variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage({ id: 'Load.MailupCommon.Recipients' })}{' '}
            {intl.formatNumber(Messages.find(m => m.TipoInvio === 2).Queued)}
          </Text>
          <SpacingVertical variant={SPACING_8} />
          <ProgressBarSmall
            perc={intl.formatNumber(100 - Info.PercTest, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 0
            })}
          />
        </FlexItem>
      </Flex>
    </Panel>
  )
}

export default AbTestWinnerMessage
